import { render } from "./RestaurantFoodLoader.vue?vue&type=template&id=183b7d6b"
import script from "./RestaurantFoodLoader.vue?vue&type=script&lang=js"
export * from "./RestaurantFoodLoader.vue?vue&type=script&lang=js"

import "./RestaurantFoodLoader.vue?vue&type=style&index=0&id=183b7d6b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__